import { combineReducers } from 'redux';

import main from './../reducers/main';
import offices from './../reducers/offices';
import services from './../reducers/services';
import intervals from './../reducers/intervals';
import reservation from './../reducers/reservation';
import confirmEmail from './../reducers/confirmEmail';
import deleteReservation from './../reducers/deleteReservation';
import officeStats from './../reducers/officeStats';
import stats from './../reducers/stats';


export default combineReducers({
  main,
  offices,
  services,
  intervals,
  reservation,
  confirmEmail,
  deleteReservation,
  officeStats,
  stats,
});



// WEBPACK FOOTER //
// ./src/store/configureReducers.js